import React, { useState, useEffect } from 'react'

import PropTypes from 'prop-types'

import { makeStyles } from '@material-ui/core/styles'

import {
  InputLabel, FormControl, FormHelperText, FilledInput,
  Button, InputAdornment, IconButton, Typography,
  Dialog, DialogTitle, DialogContent, Grid
} from '@material-ui/core'

import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  resetBtn: {
    backgroundColor: '#5291fc',
    color: '#fff',
    width: '75%',
    '&:hover': {
      backgroundColor: '#1F5EC9',
      color: '#fff'
    }
  },
  passwordfield: {
    backgroundColor: '#EFF5F7',
    opacity: 0.75,
    '&:hover': {
      backgroundColor: '#BCC2C4'
    }
  },
  margin: {
    margin: theme.spacing(1)
  },
  textField: {
    width: 'auto'
  },
  greenText: {
    color: '#97b557'
  }
}))

/**
 * Component displays a modal used to reset password or prompt user for password
 * @param {Object} props props object
 ** @param {Boolean} passwordModal state for modal
 ** @param {Function} togglePasswordModal function to close modal
 ** @param {Function} onResetPassword function used when a user clicks confirm
 */
const ForcePasswordReset = (props) => {
  const { passwordModal, onResetPassword } = props

  const MuiClasses = useStyles()

  const [adminPassword, setAdminPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [confirmError, setConfirmError] = useState(false)

  const [showPassword, setShowPassword] = useState({
    adminPassword: false,
    newPassword: false,
    confirmPassword: false
  })

  useEffect(() => {
    if (confirmPassword !== '') {
      confirmPassword === newPassword ? setConfirmError(false) : setConfirmError(true)
    }
  }, [confirmPassword, newPassword])

  const handleResetPassword = async (e) => {
    e.preventDefault()
    const resetStat = await onResetPassword(adminPassword, newPassword, confirmPassword)
    if (resetStat === true) {
      setAdminPassword('')
      setNewPassword('')
      setConfirmPassword('')
      setConfirmError(false)
    }
  }

  return (
    <Dialog open={passwordModal} className='filterModal' fullWidth maxWidth='sm' disableBackdropClick disableEscapeKeyDown>

      <DialogTitle disableTypography>
        <Typography
          variant='h4'
          color='primary'
          classes={{ colorPrimary: MuiClasses.greenText }}
          className='font-weight-bold'
        >
          Reset Your Password
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container direction='column'>

          <FormControl className={clsx(MuiClasses.margin, MuiClasses.textField)} variant='filled'>
            <InputLabel htmlFor='admin-password'>
              Your Current Password
            </InputLabel>
            <FilledInput
              id='admin-password'
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              className={`w-100 mb-2 ${MuiClasses.passwordfield}`}
              variant='filled'
              type={showPassword.adminPassword ? 'text' : 'password'}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={(e) => {
                      e.preventDefault()
                      setShowPassword({ ...showPassword, adminPassword: !showPassword.adminPassword })
                    }}
                  >
                    {showPassword.adminPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <FormControl className={clsx(MuiClasses.margin, MuiClasses.textField)} variant='filled'>
            <InputLabel htmlFor='initial-new-supervisor-password'>
              New Password
            </InputLabel>
            <FilledInput
              id='initial-new-supervisor-password'
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className={`w-100 mb-2 ${MuiClasses.passwordfield}`}
              variant='filled'
              type={showPassword.newPassword ? 'text' : 'password'}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={(e) => {
                      e.preventDefault()
                      setShowPassword({ ...showPassword, newPassword: !showPassword.newPassword })
                    }}
                  >
                    {showPassword.newPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <FormControl className={clsx(MuiClasses.margin, MuiClasses.textField)} variant='filled'>
            <InputLabel htmlFor='confirm-supervisor-password'>
              Confirm New Password
            </InputLabel>
            <FilledInput
              id='initial-confirm-supervisor-password'
              value={confirmPassword}
              error={confirmError}
              onChange={(e) => {
                setConfirmPassword(e.target.value)
              }}
              className={`w-100 mb-2 ${MuiClasses.passwordfield} border border-bottom-success`}
              variant='filled'
              type={showPassword.confirmPassword ? 'text' : 'password'}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={(e) => {
                      e.preventDefault()
                      setShowPassword({ ...showPassword, confirmPassword: !showPassword.confirmPassword })
                    }}
                  >
                    {showPassword.confirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
            <FormHelperText>Click confirm after entering your password to be redirected</FormHelperText>
          </FormControl>
          <Button variant='outlined' className={`mx-auto ${MuiClasses.resetBtn}`} onClick={handleResetPassword}>Confirm</Button>

        </Grid>
      </DialogContent>
    </Dialog>
  )
}

ForcePasswordReset.propTypes = {
  passwordModal: PropTypes.bool.isRequired,
  // last name of user in case of admin case password reset
  onResetPassword: PropTypes.func.isRequired
}

export default ForcePasswordReset
